import { render } from "./Photopage.vue?vue&type=template&id=709e0065&scoped=true&ts=true"
import script from "./Photopage.vue?vue&type=script&lang=ts"
export * from "./Photopage.vue?vue&type=script&lang=ts"

import "./Photopage.vue?vue&type=style&index=0&id=709e0065&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709e0065"]])

export default __exports__